import { render, staticRenderFns } from "./StudentAssignmentForm.vue?vue&type=template&id=1fcbf777&scoped=true&"
import script from "./StudentAssignmentForm.vue?vue&type=script&lang=js&"
export * from "./StudentAssignmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcbf777",
  null
  
)

export default component.exports